import { useState } from 'react';
import { Link } from 'react-router-dom';

interface HeaderProps {
  scrolled: boolean;
}

export default function Header({ scrolled }: HeaderProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/0273dd44fb07edcab3400783208c41a6/6a2b628e8161088f2d883f2cd1004b23.png" 
              alt="wonder craft company" 
              className="h-8"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-12">
            <Link
              to="/company"
              className={`text-sm font-medium tracking-wider transition-colors ${
                scrolled ? 'text-black hover:text-gray-600' : 'text-white hover:text-gray-200'
              }`}
            >
              COMPANY
            </Link>
            <Link
              to="/service"
              className={`text-sm font-medium tracking-wider transition-colors ${
                scrolled ? 'text-black hover:text-gray-600' : 'text-white hover:text-gray-200'
              }`}
            >
              SERVICE
            </Link>
            <Link
              to="/news"
              className={`text-sm font-medium tracking-wider transition-colors ${
                scrolled ? 'text-black hover:text-gray-600' : 'text-white hover:text-gray-200'
              }`}
            >
              NEWS
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium tracking-wider transition-colors ${
                scrolled ? 'text-black hover:text-gray-600' : 'text-white hover:text-gray-200'
              }`}
            >
              CONTACT
            </Link>
          </nav>

          {/* Mobile Hamburger Button */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-black' : 'text-white bg-white/20 backdrop-blur-sm'
            }`}
            aria-label="メニューを開く"
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-white shadow-lg transition-all duration-300 overflow-hidden ${
          menuOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="flex flex-col py-4">
          <Link
            to="/company"
            onClick={() => setMenuOpen(false)}
            className="px-6 py-4 text-sm font-medium tracking-wider text-black hover:bg-gray-50 transition-colors"
          >
            COMPANY
          </Link>
          <Link
            to="/service"
            onClick={() => setMenuOpen(false)}
            className="px-6 py-4 text-sm font-medium tracking-wider text-black hover:bg-gray-50 transition-colors"
          >
            SERVICE
          </Link>
          <Link
            to="/news"
            onClick={() => setMenuOpen(false)}
            className="px-6 py-4 text-sm font-medium tracking-wider text-black hover:bg-gray-50 transition-colors"
          >
            NEWS
          </Link>
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="px-6 py-4 text-sm font-medium tracking-wider text-black hover:bg-gray-50 transition-colors"
          >
            CONTACT
          </Link>
        </nav>
      </div>
    </header>
  );
}
